"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString24hr = exports.isString12hr = exports.isCompleteTimeObject = exports.isTimeObject = exports.isAmTimeObject = exports.isAmString24hr = exports.isAmString12hr = exports.isAmHrs24 = exports.isPmTimeObject = exports.isPmString24hr = exports.isPmString12hr = exports.isPmHrs24 = exports.isShiftHeldDown = void 0;
var utils_1 = require("../../helpers/utils");
var regex_1 = require("../regex/regex");
var staticValues_1 = require("../staticValues");
var utils_2 = require("../utils/utils");
exports.isShiftHeldDown = false;
window.addEventListener('keyup', function (e) { return (exports.isShiftHeldDown = e.shiftKey); });
window.addEventListener('keydown', function (e) { return (exports.isShiftHeldDown = e.shiftKey); });
var isValidTimeString = function (_a) {
    var value = _a.value, format = _a.format, minHrs = _a.minHrs, maxHrs = _a.maxHrs;
    var isFormatValid = regex_1.regex[format].test(value);
    if (!isFormatValid)
        return false;
    var parsedString = regex_1.regex[format].exec(value) || [];
    var hrsVal = utils_2.toNumber(parsedString[1]);
    var minsVal = utils_2.toNumber(parsedString[2]);
    var isHrsValid = hrsVal === null || (hrsVal >= minHrs && hrsVal <= maxHrs);
    var isMinsValid = minsVal === null || (minsVal >= 0 && minsVal <= 59);
    return isHrsValid && isMinsValid;
};
exports.isPmHrs24 = function (hrs24) { return hrs24 !== null && 12 <= hrs24 && hrs24 < 24; };
exports.isPmString12hr = function (string12hr) { var _a; return ((_a = regex_1.regex.string12hr.exec(string12hr)) === null || _a === void 0 ? void 0 : _a[3]) === 'PM'; };
exports.isPmString24hr = function (string24hr) {
    var _a;
    if (string24hr === '')
        return false;
    var hrs24 = utils_2.toNumber(((_a = regex_1.regex.string24hr.exec(string24hr)) === null || _a === void 0 ? void 0 : _a[1]) || '');
    return typeof hrs24 == 'number' && hrs24 > 11;
};
exports.isPmTimeObject = function (timeObject) {
    if (!timeObject.mode && timeObject.hrs24 !== null) {
        return timeObject.hrs24 > 11;
    }
    return timeObject.mode === 'PM';
};
exports.isAmHrs24 = function (hrs24) { return hrs24 !== null && !exports.isPmHrs24(hrs24); };
exports.isAmString12hr = function (string12hr) {
    return regex_1.regex.string12hr.test(string12hr) &&
        string12hr.indexOf('--') === -1 &&
        !exports.isPmString12hr(string12hr);
};
exports.isAmString24hr = function (string24hr) {
    return string24hr !== '' && !exports.isPmString24hr(string24hr);
};
exports.isAmTimeObject = function (timeObject) {
    return !exports.isPmTimeObject(timeObject) && exports.isCompleteTimeObject(timeObject);
};
exports.isTimeObject = function (value) {
    if (typeof value === 'undefined' || typeof value !== 'object')
        return false;
    var keys = Object.keys(value);
    if (keys.length === 0)
        return false;
    var filteredKeys = staticValues_1.timeObjectKeys.filter(function (key) { return keys.indexOf(key) === -1; });
    var additionalKeys = keys.filter(function (key) {
        // key might not be a TimeObjectKey but that is exactly what I'm checking for here
        return staticValues_1.timeObjectKeys.indexOf(key) === -1;
    });
    return filteredKeys.length === 0 && additionalKeys.length === 0;
};
exports.isCompleteTimeObject = function (timeObject) {
    if (!exports.isTimeObject(timeObject)) {
        return false;
    }
    return utils_1.getKeys(timeObject).every(function (key) { return timeObject[key] !== null; });
};
exports.isString12hr = function (value) {
    return isValidTimeString({ value: value, format: 'string12hr', minHrs: 1, maxHrs: 12 });
};
exports.isString24hr = function (value) {
    if (value === '')
        return true;
    return isValidTimeString({ value: value, format: 'string24hr', minHrs: 0, maxHrs: 23 });
};
